if (!customElements.get('cutekit-product-finder')) {
 class CuteKitProductFinder extends HTMLElement {
  connectedCallback() {
   if (this.ready) return; this.ready = true;
   this.tabs = [...this.querySelectorAll('[data-category]')];
   this.panels = [...this.querySelectorAll('[data-panel]')];
   this.querySelector('.ckpf-tabs').setAttribute('role', 'tablist');
   this.tabs.forEach((tab, i) => {
    tab.setAttribute('role', 'tab');
    tab.addEventListener('click', () => this.select(tab.dataset.category));
    tab.addEventListener('keydown', e => {
     let next;
     if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
     if (e.key === 'ArrowLeft') next = (i + this.tabs.length - 1) % this.tabs.length;
     if (e.key === 'Home') next = 0;
     if (e.key === 'End') next = this.tabs.length - 1;
     if (next !== undefined) { e.preventDefault(); this.select(this.tabs[next].dataset.category); this.tabs[next].focus(); }
    });
   });
   this.panels.forEach(p => { p.setAttribute('role', 'tabpanel'); p.tabIndex = 0; });
   this.hashHandler = () => { if (/^#compare-(feeders|fountains)$/.test(location.hash)) { this.select(location.hash.slice(9)); this.scrollIntoView({block:'start'}); } };
   this.select(location.hash === '#compare-fountains' ? 'fountains' : 'feeders');
   window.addEventListener('hashchange', this.hashHandler);
   this.editorHandler = e => { const panel = e.target.closest('[data-panel]'); if (panel && this.contains(panel)) this.select(panel.dataset.panel); };
   document.addEventListener('shopify:block:select', this.editorHandler);
  }
  select(category) { this.tabs.forEach(t => { const active = t.dataset.category === category; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; }); this.panels.forEach(p => p.hidden = p.dataset.panel !== category); }
  disconnectedCallback() { window.removeEventListener('hashchange', this.hashHandler); document.removeEventListener('shopify:block:select', this.editorHandler); }
 }
 customElements.define('cutekit-product-finder', CuteKitProductFinder);
}